import React from 'react';
import { BankOutlined } from '@ant-design/icons';
import {
    DonutChart,
    Legend,
    LegendOrientations,
    Text,
} from '@clockout-dev/design-elements';
import MetricCard from '../../common/metricCard/MetricCard';
import { ACCOUNT_BREAKDOWN_ITEMS } from '../treasury.constants';
import { formatFullCurrency } from '../../../utils/numbers';
import styles from './styles/accountBalanceCard.module.scss';

/**
 * Top-left card on Cashflow Management. Pure presentational shell that
 * composes the shared `MetricCard` (icon + ACCOUNT / GL name in the
 * title block) with a body that splits into a balance + legend column
 * on the left and the donut chart on the right. Donut and legend slices
 * stay in sync via `ACCOUNT_BREAKDOWN_ITEMS` — same array drives both.
 */
function AccountBalanceCard({ data }) {
    const name = data?.name ?? 'Advance GL';
    const balance = data?.balance ?? null;
    const breakdown = data?.breakdown ?? { advanced: 0, overdue: 0, available: 0 };

    const slices = ACCOUNT_BREAKDOWN_ITEMS.map((item) => ({
        label: item.label,
        color: item.color,
        value: breakdown?.[item.key] ?? 0,
    }));
    const legendItems = ACCOUNT_BREAKDOWN_ITEMS.map(({ label, color }) => ({ label, color }));

    return (
        <MetricCard
            image={<BankOutlined />}
            title={{ label: 'Account', description: name }}>
            <div className={styles.body}>
                <div className={styles.left}>
                    <div className={styles.balance}>
                        <div className={styles.balanceLabel}>Account Balance</div>
                        <Text size="display-s" className={styles.balanceValue}>{formatFullCurrency(balance)}</Text>
                    </div>
                    <Legend items={legendItems} orientation={LegendOrientations.HORIZONTAL} />
                </div>
                <div className={styles.right}>
                    <DonutChart
                        data={slices}
                        size={168}
                        formatValue={(value) => `$${Math.round(value).toLocaleString('en-US')}`}
                    />
                </div>
            </div>
        </MetricCard>
    );
}

export default AccountBalanceCard;
